import clone from 'lodash/clone';

import AdministrationDashboard from 'src/pages/AdministrationDashboard';
import IssueOverview from 'src/pages/IssuesOverview';
import NotFound from 'src/pages/NotFound';
import Report from 'src/pages/Report';
import ReportsList from 'src/pages/ReportsList';
import UsersManagement from 'src/pages/UsersManagement';
import { RouteConfigType, SubRoute } from 'src/redux/routesConfig/types';

export const sectionPrefix = 'section-';

const _year_match = ':year',
  _cpb_key_match = ':cpb',
  _section_match = `:section(${sectionPrefix}.*)?`,
  _project = `${_year_match}/${_cpb_key_match}`,
  _section_with_section = `${_project}/${_section_match}`;

export const routesConfig: RouteConfigType = {
  root: {
    path: `/`,
    name: 'Home',
    sub_routes: {
      admin_dashboard: {
        path: '/admin-dashboard',
        name: 'Administration Dashboard',
        component: AdministrationDashboard,
      },
      users_management: {
        path: '/users-management',
        name: 'Users Management',
        component: UsersManagement,
      },
      all_comments: {
        path: `/${_project}/comments`,
        name: 'View all narratives and comments',
        component: IssueOverview,
      },
      report_detail_no_section: {
        path: `/${_project}`,
        name: 'Report Detail without Section',
        matchToName: (match, country) => {
          return `${match.params.cpb.toUpperCase()} ${country || ''}`.trim();
        },
        component: Report,
      },
      report_detail_with_section: {
        path: `/${_section_with_section}`,
        name: 'Report Detail with Section',
        matchToName: (match, country) => {
          return `${match.params.cpb.toUpperCase()} (${match.params.section}) ${
            country || ''
          }`.trim();
        },
        component: Report,
      },
      reports_dashboard: {
        path: `/${_year_match}?`,
        name: 'Reports Dashboard',
        matchToName: match => `${match.params.year || ''}`,
        component: ReportsList,
      },
      not_found: {
        path: '/not-found',
        name: 'Not Found',
        component: NotFound,
      },
    },
  },
};

export function getAppRoutes(rootUri: string): RouteConfigType {
  const result = clone(routesConfig);

  const normalizeUri = (uri: string) => `/${uri}/`.replace(/\/+/g, '/');
  const joinUri = (array: string[]) => normalizeUri(array.join('/'));

  const prepareRoutes = (
    routes: RouteConfigType | { [key: string]: SubRoute },
    parentUri = joinUri([rootUri || '/']),
  ): void => {
    for (const key in routes) {
      let currentUri = parentUri;
      if (routes[key].hasOwnProperty('path')) {
        currentUri = joinUri([currentUri, routes[key].path]);
        routes[key].path = currentUri;
      }

      if (routes[key].hasOwnProperty('sub_routes')) {
        prepareRoutes(routes[key].sub_routes, currentUri);
      }
    }
  };
  prepareRoutes(result);
  return result;
}
